import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import { getApiErrorMessage } from "src/types/api";
import axiosInstance from "src/store/features/auth/axiosCSRF";

export interface iLambdaCallResultState {
    response: any;
    isLoading: boolean;
    message: string | null;
    error : string | null;
}

const initialState: iLambdaCallResultState = {
    response: null,
    isLoading: false,
    message: "",
    error: null,
};

// Lambda Results API 호출
export const lambdaResultsAPI = createAsyncThunk(
    "LAMBDA_CALL_RESULT",
    async (params: { 
        group_name: string;  
        workflow_name: string; 
        library_name: string; 
        round_num: number; 
        lambda_name: string;  // job_id로 수정
    }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            // job_id를 파라미터로 사용
            const pathParam = `/tools/function-result/?group_name=${params.group_name}&library_name=${params.library_name}&lambda_name=${params.lambda_name}&round_num=${params.round_num}`;
            
            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`, {
                withCredentials: true,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(getApiErrorMessage(error));
        }
    }
);


// Lambda Results Slice
export const lambdaResultsSlice = createSlice({
    name: "lambdaCallResult",  // name 수정 (중복 방지)
    initialState,
    reducers: {
        // 결과 초기화 액션 추가
        resetLambdaResults: (state) => {
            state.response = null;
            state.isLoading = false;
            state.message = "";
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(lambdaResultsAPI.pending, (state) => {
                state.isLoading = true;
                state.message = "";
                state.error = null;
            })
            .addCase(lambdaResultsAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
                state.message = "Results retrieved successfully";
            })
            .addCase(lambdaResultsAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
                state.error = action.payload as string;
            });
    },
});

export const { resetLambdaResults } = lambdaResultsSlice.actions;
export default lambdaResultsSlice.reducer;